<template>
  <div class="map-box">
    <div class="lmy-map-back">
      <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
    </div>
    <div class="lmy-map-toggle" v-if="from==1">
      <div :class="isWalking?'toggle-item':'toggle-item active' " @click="isWalking=false">驾车</div>
      <div :class="isWalking?'toggle-item active':'toggle-item'" @click="isWalking=true">步行</div>
    </div>
    
    <!-- 国内 -->
    <div v-if="m2&&from==1" class="map-area">
      <baidu-map class="map" NavigationControlType='BMAP_NAVIGATION_CONTROL_LARGE' ak="UwrDLDbFuAtRiZXGzkgx4c3m"
                 :scroll-wheel-zoom="true" @ready="handler">
        <bm-driving
          :start="{lng: m1, lat: m2}"
          :end="{lng:lng, lat: lat}"
          :panel="false"
          :auto-viewport="true"
          v-if="!isWalking"
        ></bm-driving>
        <bm-view class="map">
        </bm-view>
        <bm-walking :start=" {lng: m1, lat: m2}" :end=" {lng: lng, lat:lat}" :panel="false" :auto-viewport="true"
                    v-if="isWalking"></bm-walking>

        <bml-marker-clusterer :averageCenter="true" :auto-viewport="true" v-if="points&&points.length>0">
            <bm-marker v-for="(marker,index) of points" :key="marker.lng+index" :position="{lng: marker.lng, lat: marker.lat}" v-if="marker.lng!=lng&&marker.lat!=lat" ></bm-marker>
        </bml-marker-clusterer>


      </baidu-map>
    </div>

    <!-- 海外 -->
    <div v-if="from==0" class="map-area">
      <baidu-map class="map" ak="UwrDLDbFuAtRiZXGzkgx4c3m" :center="center" :zoom="18" @ready="frHandler">
        <bm-marker :position="center">
          <!-- <bm-label :content="content"  :labelStyle="labelStyle" :offset="{width: -60, height: 30}" /> -->
        </bm-marker>
      </baidu-map>
    </div>

    <!-- 周围地点 -->
    
    
    <div class="lmy-map show-list" v-if="from==1" >
    <div class="map-line" @click="showListNum=(showListNum||3)"><span></span></div>
      <ul class="lmy-map-menu" id="swipeCalendar">
        <li :class="activePage=='page1'?'menu-list active':'menu-list'" @click="selectPage('page1','交通')"><span>交通</span></li>
        <li :class="activePage=='page2'?'menu-list active':'menu-list'" @click="selectPage('page2','景点')"><span>景点</span></li>
        <li :class="activePage=='page3'?'menu-list active':'menu-list'" @click="selectPage('page3','美食')"><span>美食</span></li>
        <li :class="activePage=='page4'?'menu-list active':'menu-list'" @click="selectPage('page4','购物')"><span>购物</span></li>
      </ul>
      <ul class="lmy-map-content" :style="'height:'+showListNum+'rem'">
        <li :class="lm.active?'active':''" v-for="lm in lmList" v-if="lmList.length&&lmList.length>0">
          <p class="title">{{lm.Name}}<span>{{lm.Cat}}</span></p>
          <p class="detail">{{lm.Info}}</p>
          <span class="nav" @click="clickHandler({lng:lm.LON,lat:lm.LAT},lm,lmList)">导航</span>
        </li>

        <li v-if="!lmList.length||lmList.length<=0">没有相关地点</li>
      </ul>
    </div>

  </div>
</template>

<script>
  import {BmView, BaiduMap,MarkerClusterer, BmMarker, BmLabel, BmPointCollection, BmWalking, BmDriving} from 'vue-baidu-map';

  export default {

    components: {
      BaiduMap,
      BmView,
      BmMarker,
      BmLabel,
      BmPointCollection,
      MarkerClusterer,
      BmWalking,
      BmDriving
    },
    data() {
      return {
        center: {lng: 116.404, lat: 39.915},
        lat: Number(this.$route.query.lat),
        lng: Number(this.$route.query.lng),
        m1: Number(this.$route.query.m1),
        m2: Number(this.$route.query.m2),
        from: this.$route.query.from == 0 ? 0 : 1,
        isWalking: false,
        points: [],
        Lamndmarks:JSON.parse(this.dao.get('mapLamndmarks')), 
        lmList:'',
        activePage:'',
        labelStyle: {
          color: '#444',
          fontSize: '14px',
          borderRadius: '4px',
          padding: '3px 5px',
          width: '120px',
          textAlign: 'center',
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        },
        showListNum: 0,
        content: ''
      }
    },
    methods: {
      frHandler({BMap, map}) {

        this.setMapHeight();
        var lng = Number(this.$route.query.lng);
        var lat = Number(this.$route.query.lat);

        this.center.lng = lng;
        this.center.lat = lat;
        this.content = this.$route.query.content;

      },
      selectPage(page,name){
        this.activePage=page;
        this.showListNum=this.showListNum||3;
        this.lmList=this.Lamndmarks[name]||'';
        this.points=[];
        this.lat=Number(this.$route.query.lat);
        this.lng=Number(this.$route.query.lng);
        var list=this.lmList;
        for(var i=0;i<list.length;i++){
          this.points.push({lng:list[i].LON,lat:list[i].LAT})
        }
      },
      handler({BMap, map}) {
        this.setMapHeight();
        this.selectPage('page1','交通');
      },
      clickHandler(e,lm,list) {

        this.$nextTick(function () {
          for(var i=0;i<list.length;i++){
            list[i].active=false;

          }
          this.$set(lm,'active',lm.active?false:true);
        });
        this.lng=e.lng;
        this.lat=e.lat;
      },
      setMapHeight() {
        var height = window.screen.height;
        var div = document.getElementsByClassName('map-box')[0];
        div.style.height = height + 'px';
      },
      initSwipe() {
        if(this.from==0)return;

        
        var that = this;
        var div = document.getElementById('swipeCalendar');
        div.addEventListener('touchstart', touch, false);
        div.addEventListener('touchend', touch, false);
        var pagey;
        function touch(event) {
          var event = event || window.event;
          switch (event.type) {
            case "touchstart":
              pagey = event.touches[0].clientY;
              break;
            case "touchend":
              if (event.changedTouches[0].clientY - pagey > 10) {
                // that.prev();
                that.touchDown();
              } else if (event.changedTouches[0].clientY - pagey < -10) {
                // that.next();
                that.touchTop();
              }
              break;
            case "touchmove":
              event.preventDefault();
              break;
          }
        }
      },
      touchTop() {

        switch (this.showListNum) {
          case 0:
            this.showListNum = 3;
            break;
          case 3:
            this.showListNum = 6;
            break;
        }
       
      },
      touchDown() {
        switch (this.showListNum) {
          case 6:
            this.showListNum = 3;
            break;
          case 3:
            this.showListNum = 0;
            break;
        }
      }
    },
    mounted() {
      this.setMapHeight();
      this.initSwipe();
      // this.lmList=this.Lamndmarks['交通']||'';

    }


  }

</script>

<style scoped>
  .map-area {
    width: 100%;
    height: 100%;
  }

  .map-box {
    width: 100%;
    height: 100%;

  }

  .map {
    width: 100%;
    height: 100%;
  }
  .lmy-map-content>li.active{
    background-color: #fff3f3;

  }


</style>



// WEBPACK FOOTER //
// src/components/common/cmpnt/map.vue